import React from "react";
import { useLocation } from "react-router-dom";
import { useMenuState } from "@assets/contexts/MenuContext";

const PermissionPage = ({ children }) => {
  const location = useLocation();
  const value = useMenuState();
  const arr = location.pathname.split("/").filter((data, i) => i !== 0);
  let strArr = Object.values(value.menu);

  const pageCheck = (children) => {
    let pagePerCheck = false;
    const newSt = strArr;
    const findData = newSt.findIndex((data) => data.eName === arr[0]);

    if (findData !== -1) {
      if (arr.length === 1) {
        pagePerCheck = strArr[findData].permission || arr[0] === "";
      } else if (arr.length === 2 && strArr[findData].sub !== null) {
        let strArrSub = Object.values(newSt[findData].sub);
        const findSubData = strArrSub.findIndex(
          (data) => data.eName === arr[1]
        );

        pagePerCheck = findSubData !== -1 && strArrSub[1].permission && true;
      }
    } else {
      pagePerCheck = arr[0] === "" ? true : false;
    }
    return <>{pagePerCheck ? <>{children}</> : <></>}</>;
  };
  return <>{pageCheck(children)}</>;
};

export default PermissionPage;
